import { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "./login.css";
import Popup from "../common/popup/Popup";
import { UserContext } from "../../UserContext";

import { Link, useNavigate } from "react-router-dom";
import OtpInput from "./OtpInput";
import { callback } from "../../callback";
import { PopupContext } from "./LoginPopupContext";

export default function MobileNumber() {
  const { hideSignupDialog, showSignupDialog } = useContext(PopupContext);
  const [loginSucessMsg, setLoginSucessMsg] = useState();
  const { sessionData, loggedIn } = useContext(UserContext);
  const phoneRegex = /^\+\d{1,4}\d{6,14}$/;
  const [errMsg, setErrmsg] = useState(false);
  const [isSuccessMsg, setIsSuccessMsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showcPassword, setcShowPassword] = useState(false);
  const [usernameAvil, setUsernameAvail] = useState(false);
  const [numberAvil, setNumberAvail] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [agreeR, setAgreeR] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    userName:"",
    mobileNo: "",
    email: "",
    hidden: "",
    referrer: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    fullName: "",
    userName: "",
    mobileNo: "",
    email: "",
    referrer: "",
    password: "",
    confirmPassword: "",
  });

   const handleAgreeChangeR = (e) => {
    setAgreeR(e.target.checked);
  };

   useEffect(() => {
     if (isSuccessMsg) {
      const intervalId = setInterval(() => {
        setIsSuccessMsg(false);
        setMsg("");
        handleCloses();
      }, 2000);

      return () => {
        clearInterval(intervalId);
      };
    }

}, [isSuccessMsg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "userName") {
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0) {
      setErrors((prev) => ({
        ...prev,
        userName: "Username is required",
      }));
      setUsernameAvail(false);
      setFormDatas(name, value,false);
    } else if (trimmedValue.length > 10) {
      setErrors((prev) => ({
        ...prev,
        userName: "Username must not exceed 10 characters",
      }));
      setUsernameAvail(false);
    } else {
      setErrors((prev) => ({
        ...prev,
        userName: "",
      }));
      setUsernameAvail(true);
      setFormDatas(name, value,true);
    }
  }else{
    setFormDatas(name, value,true);
  }
  };

  const setFormDatas = (name,value,error) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear the error as user types
    if (error) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  }

  const validateForm = () => {
    const newErrors = {};
    if (!formData.userName) newErrors.userName = "User Name is required";
    if (!formData.mobileNo) {
      newErrors.mobileNo = "Mobile Number is required";
    } else if (!phoneRegex.test(formData.mobileNo)) {
      newErrors.mobileNo = "Invalid Mobile Number";
    }

    if (!formData.password) newErrors.password = "Password is required";
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleRSubmit = () => {
    const newErrors = validateForm();
    setErrors(newErrors);   
     if (Object.keys(newErrors).length === 0) {
      if (agreeR) {
        if(formData.hidden === ""){
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
  
          const raw = JSON.stringify({
            "whiteLabelName": window.location.hostname,
            "password": formData.password,
            "passwordConfirm": formData.confirmPassword,
            "userName": formData.userName,
            "contectNumber": formData.mobileNo,
            "name": formData.fullName,
            "referrer": formData.referrer,
            "email": formData.email
          });
  
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
          };
  
          fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/users/createUser`, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            console.log("createUser :", data);
            if (data.status != "Error") {
              setIsSuccessMsg(true);
              setMsg("Successfully registered!")
            } else {
              setMsg(data.message)
              setErrmsg(true);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            // Handle login error
          });
        }else{
          setMsg("Something went wrong, please try again later.")
          setErrmsg(true);
          window.location.reload();
        }
      }else {
        setMsg("To continue, kindly check the box to agree to our terms and conditions.")
        setErrmsg(true);
      }
    } else {
    
    }
  };

  useEffect(() => {
    if(loginSucessMsg){
      const setloginsucessMsg = setTimeout(() => {
        setLoginSucessMsg(false);
      }, 2000);

      return () => {
        clearTimeout(setloginsucessMsg);
      };
    }
  }, [sessionData]);

    const handleClose = () => {
    hideSignupDialog();
    console.log("Closing signup dialog MobileNumber.js",new Date());
  }

  const handleCloses = () => {
    handleClose();
  }

  const checkUsername = (name) => {
        let data = JSON.stringify({
            "userName":name
        })
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
          body: data,
        };
    
        fetch(`${process.env.REACT_APP_BASE_URL}/checkUserName`, requestOptions)
          .then(async (response) => {
            let paresData = await response.json();
            if(paresData.status === "Error"){
              setErrors((prev) => ({
                ...prev,
                userName: paresData.message
              }));
              setUsernameAvail(false);
            }else{
              setUsernameAvail(true);
              setErrors((prev) => ({
                ...prev,
                userName: ""
              }));
            }
            console.log("checkUserName - ",paresData );
          })
          .catch((error) => {
            console.log(error);
          });
      }

  const checkPhonenumber = (number) => {
        let data = JSON.stringify({
            "contact":number
        })
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
          body: data,
        };
    
        fetch(`${process.env.REACT_APP_BASE_URL}/checkNumber`, requestOptions)
          .then(async (response) => {
            let paresData = await response.json();
            if(paresData.status === "Error"){
              setErrors((prev) => ({
                ...prev,
                mobileNo: paresData.message
              }));
              setNumberAvail(false);
            }else{
              setNumberAvail(true);
              setErrors((prev) => ({
                ...prev,
                mobileNo: ""
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }

  useEffect(() => {
    if (formData.userName.trim().length > 0) {
      if(formData.userName.trim().length > 3){
        checkUsername(formData.userName);
      }else{
        setUsernameAvail(false);
        setErrors((prev) => ({
          ...prev,
          userName: "The Username must be at least 4 characters"
        }));
      }
    }
  }, [formData.userName]);

  return (
    <div>
                {<form className="myloginmodl-form-dv signup-form">
                  <div className="row">
                
                  <input
                      type="hidden"
                      name="hidden"
                      style={{ display: "none" }}
                      autoCapitalize="off"
                      spellCheck="false"
                      autoComplete="new-username"
                      placeholder="Enter Username1"
                      value={formData.hidden}
                      onChange={handleChange}
                      required
                    />
                  <div className="input-group col-6 user-name">
                    <label>Username *</label>
                    <input
                      type="text"
                      name="userName"
                      autoCapitalize="off"
                      spellCheck="false"
                      autoComplete="new-username"
                      placeholder="Enter Username"
                      value={formData.userName}
                      onChange={handleChange}
                       onBlur={(e) => 
                          {
                            if(e.target.value.trim().length > 0 && e.target.value.trim().length < 4){
                              setErrors((prev) => ({
                                ...prev,
                                userName: "The Username must be at least 4 characters"
                              }));
                              setUsernameAvail(false);
                            }else if(e.target.value.trim().length > 3){
                              checkUsername(e.target.value);
                            }else{
                              setErrors((prev) => ({
                                ...prev,
                                userName: ""
                              }));
                              setUsernameAvail(true);
                            }
                            if(e.target.value.trim().length === 0){
                              setErrors((prev) => ({
                                ...prev,
                                userName: "Username is required"
                              }));
                              setUsernameAvail(false);
                            }
                          }
                        }
                      required
                    />
                    {errors.userName && !usernameAvil && <span className="user-msg error">{errors.userName}</span>}
                    {usernameAvil && formData.userName.trim().length > 3 && <span className="user-msg success">User name is available</span>}
                  </div>
                  <div className="input-group col-6 new-password"> 
                    <label>New Password *</label>
                    <div class="input-with-icon">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      autoComplete="new-password"
                      autoCapitalize="off"
                      spellCheck="false"
                      placeholder="New Password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <span className="icon" onClick={() => setShowPassword(!showPassword)}>
                        <i className={`fa-solid ${
                      showPassword ? "fa-eye" : "fa-eye-slash"
                    }`}></i>
                      </span>
                    </div>
                    {errors.password && <span className="error">{errors.password}</span>}
                  </div>
                  <div className="input-group col-6 mobile-number">
                  <div className={`tooltip-mobile-number ${tooltip ? 'show':''}`}> The entered number will be used for user verification in case of a forgotten password. </div>
                    <label>Phone No.</label>
                        <PhoneInput
                        name="mobileNo"
                        country={"in"}
                        enableSearch={true}
                        value={formData.mobileNo}
                        onBlur={(e) => 
                          {
                            
                            let phoneNumber = e.target.value.replace(/[\s-]/g, "");
                            if(!phoneRegex.test(phoneNumber)){
                              setErrors((prev) => ({
                                ...prev,
                                mobileNo: "Invalid Mobile Number"
                              }));
                              setNumberAvail(false);
                            }else{
                              setErrors((prev) => ({
                                ...prev,
                                mobileNo: ""
                              }));
                            setTooltip(true);
                            checkPhonenumber(phoneNumber);
                            setTimeout(() => {
                              setTooltip(false);
                            }, 4000);
                            }
                          }
                        }
                        onChange={(phone) => 
                          setFormData((prev) => ({
                            ...prev,
                            mobileNo: `+${phone}`,
                          }))}
                      />
                    {errors.mobileNo && !numberAvil && <span className="user-msg error">{errors.mobileNo}</span>}
                    {numberAvil && formData.mobileNo.trim().length > 3 && <span className="user-msg success">number is available</span>}
                  </div>
                  <div className="input-group col-6 confirm-password">
                    <label>Confirm Password *</label>
                    <div class="input-with-icon">
                    <input
                      type={showcPassword ? "text" : "password"}
                      name="confirmPassword"
                      autoComplete="new-password"
                      autoCapitalize="off"
                      spellCheck="false"
                      placeholder="Confirm Password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                     <span className="icon" onClick={() => setcShowPassword(!showcPassword)}>
                        <i className={`fa-solid ${
                      showcPassword ? "fa-eye" : "fa-eye-slash"
                    }`}></i>
                      </span>
                    </div>
                     {errors.confirmPassword && (
                      <span className="error">{errors.confirmPassword}</span>
                      )}
                  </div>

                  <div className="input-group col-6 referrer-code">
                    <label>Referrer Code</label>
                    <input
                      type="text"
                      name="referrer"
                      placeholder="Enter Referrer Code"
                      value={formData.referrer}
                      onChange={handleChange}
                      required
                    />

                     {errors.referrer && <span className="error">{errors.referrer}</span>}
                  </div>
                  <div className="input-group col-12 agree-box-wrapper">
                    <div className="agree-box"> 
                    <input type="checkbox" onChange={handleAgreeChangeR} id="customCheck" name="example1" class="custom-control-input" /> 
                    I am at least &nbsp; 
                    <a href="javascript:void(0)" class="text-danger" role="button">18 years</a> 
                    &nbsp;of age and I have read, accept and agree to the &nbsp;
                    <Link to="/terms-and-conditions" target="_blank">Terms and Conditions</Link>,&nbsp; 
                    <Link to="/responsible-gaming" target="_blank">Responsible Gaming</Link></div>
                  </div>
                  </div>
                  <button type="button" className="btn loginbtnn" onClick={()=>handleRSubmit()}>Register</button>
                  {/* <div class="recaptchaTerms">
                    This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
                  </div> */}
                </form>}
                <Popup
        popupClass={`alertMsgpopup ${isSuccessMsg ? "open" : ""}`}
        content={
          <div className={`alert-msg`}>
             <div className="close-btn" onClick={()=> setIsSuccessMsg(false)}>×</div>
            <span className="msg">{msg}</span>
            <div className="alert-progress-bar"></div>
          </div>
        }
      />
      <Popup
        popupClass={`alertMsgpopup Error ${errMsg ? "open" : ""}`}
        content={
          <div className={`alert-msg`}>
            <div className="close-btn" onClick={()=> setErrmsg(false)}>×</div>
            <span className="msg">{msg}</span>
            <div className="alert-progress-bar"></div>
          </div>
        }
      />
    </div>
  )
}
